export default "__VITE_ASSET__Dt4K5hJj__"